/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 1.63281V18.2995M14.1667 4.13281H7.91667C7.14312 4.13281 6.40125 4.4401 5.85427 4.98708C5.30729 5.53407 5 6.27593 5 7.04948C5 7.82303 5.30729 8.56489 5.85427 9.11187C6.40125 9.65886 7.14312 9.96615 7.91667 9.96615H12.0833C12.8569 9.96615 13.5987 10.2734 14.1457 10.8204C14.6927 11.3674 15 12.1093 15 12.8828C15 13.6564 14.6927 14.3982 14.1457 14.9452C13.5987 15.4922 12.8569 15.7995 12.0833 15.7995H5"
      stroke="#262626"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
